import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators'
import { of } from 'rxjs';
import * as StackTrace from 'stacktrace-js';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {

    constructor(private httpClient: HttpClient, private config: ConfigService) { }

    /**
     * Helper method for getting client message
     * @param error 
     * @returns 
     */
    getClientMessage(error: Error): string {
        if (!navigator.onLine) {
            return 'No Internet Connection';
        }
        return error && error.message ? error.message : 'Unexpected Client error';
    }

    /**
     * Helper method for getting error stack
     * @param error 
     * @returns 
     */
    getClientStack(error: Error): string {
        return error && error.stack ? error.stack : '';
    }

    /**
     * Helper method for getting server error
     * @param error 
     * @returns 
     */
    getServerMessage(error: HttpErrorResponse): string {
        return error && error.error && error.error.message ? error.error.message : '';
    }

    /**
     * Helper method for getting server error
     * @param error 
     * @returns 
     */
    getServerStack(error: HttpErrorResponse): any {
        return error && error.error;
    }

    /**
     * Helper method for reporting to stackdriver
     * @param error 
     * @param path 
     * @param user 
     */
    reportToStackdriver(error: Error, path: string, user: string = 'User') {
        this.resolveError(error).then(stack => {
            const reportedErrorEvent = this.errorToReportedErrorEvent(stack, path, user);
            this.sendError(reportedErrorEvent);
        });
    }

    /**
     * Method for resolving error as stackdriver call
     * @param error 
     * @returns 
     */
    private resolveError(error: Error) {

        return StackTrace.fromError(error).then(stack => {

            let lines = [error.toString()];

            stack.forEach(s => {
                lines.push([
                    '    at ',
                    s.getFunctionName() || '<anonymous>', ' (',
                    s.getFileName(), ':',
                    s.getLineNumber(), ':',
                    s.getColumnNumber(), ')',
                ].join(''));
            })

            return lines.join('\n');
        });

    }

    /**
     * Helper method to create an error event used in stackdriver
     * @param stacktrace 
     * @param url 
     * @param user 
     * @returns 
     */
    private errorToReportedErrorEvent(stacktrace: string, url: string, user: string) {
        return {
            eventTime: new Date().toISOString(),
            serviceContext: {
                service: 'web'
            },
            message: stacktrace,
            context: {
                httpRequest: {
                    url: url,
                    userAgent: navigator.userAgent
                },
                user: user
            }
        };
    }

    /**
     * Helper method for sending the error via HTTP call
     * @param reportedErrorEvent 
     */
    private sendError(reportedErrorEvent: any) {
        this.httpClient
            .post(this.config.getGCPErrorReportingApiEndpoint(), JSON.stringify(reportedErrorEvent),
                { headers: new HttpHeaders().set('Content-Type', 'application/json') })
            .pipe(
                catchError(error => of({}))
            ).subscribe();
    }


}